import React, { Component } from 'react';
import { animateScroll } from 'react-scroll';
import ConfirmationField from 'components/ConfirmationField';
import i18n from 'utils/translate';
import NavigationButtons from 'components/NavigationButtons';
import Section from 'components/Section';
import PaymentConfirmation from 'components/PaymentConfirmation';
import PersonalDataConfirmation from 'components/PersonalDataConfirmation';
import '../../constants';
import { formatPrice } from 'utils/common';
import './styles.scss';
import {
  PAYMENT_TYPE_ANNUAL,
  PAYMENT_TYPE_BIANNUAL,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_QUARTERLY
} from '../../constants';
import { calculateEndDate, paymentDetails } from '../../utils';

class Confirmation extends Component {
  state = {
    blockConfirmClick: false
  };

  componentDidMount() {
    const { onRender } = this.props;

    if (onRender) {
      onRender();
    }
    animateScroll.scrollToTop({ duration: 0 });
  }

  onClick = () => {
    this.setState({
      blockConfirmClick: true
    });

    window.dataLayer.push({
      event: 'onlineabschluss',
      formname: 'Sachverständiger- und Dolmetsch-Versicherung',
      action: 'Schritt 5 von 5'
    });
  };

  render() {
    const {
      beruf,
      fachgruppen,
      fachgebiete,
      gerichtDerEintragung,
      datumDerEintragung,
      zustaendigerLandesverband,
      versicherungsSumme = i18n('€ 400.000,-'),
      versicherungsbeginn,
      zahlungsweise,
      risikoAbgelehnt,
      risikoSchaeden,
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land,
      telefon,
      email,
      payment_type,
      iban,
      bic,
      promotion,
      loading,
      backLink,
      quote,
      apiErrorMessages,
      paymentInterval,
      onConfirm
    } = this.props;

    const personalProps = {
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land,
      telefon,
      email
    };

    const paymentProps = { type: payment_type, iban, bic };
    let paymentTypeDisplayName;

    let finalPrice = null;
    let currency = null;
    let paymentVariants = null;

    if (zahlungsweise === PAYMENT_TYPE_ANNUAL) {
      paymentTypeDisplayName = i18n('jährlich');
    } else if (zahlungsweise === PAYMENT_TYPE_BIANNUAL) {
      paymentTypeDisplayName = i18n('halbjährlich');
    } else if (zahlungsweise === PAYMENT_TYPE_QUARTERLY) {
      paymentTypeDisplayName = i18n('vierteljährlich');
    } else if (zahlungsweise === PAYMENT_TYPE_MONTHLY) {
      paymentTypeDisplayName = i18n('monatlich');
    }

    if (quote) {
      finalPrice = quote.price;
      currency = quote.currency;
      paymentVariants = quote.paymentVariants;
    }

    const endDate = calculateEndDate(versicherungsbeginn);

    return (
      <div
        className="page-step-wrapper page-step-wrapper--narrow expert-interpreter-confirmation"
        id="confirmation-wrapper"
      >
        {/* --- Insurance --- */}
        <Section header={i18n('Versicherung')}>
          <ConfirmationField title={i18n('Beruf')}>{beruf}</ConfirmationField>
          <ConfirmationField title={i18n('Fachgruppe(n)')}>
            <ul className="list-wrapper">
              {fachgruppen && fachgruppen.map((group, index) => <li key={index}>{group}</li>)}
            </ul>
          </ConfirmationField>
          <ConfirmationField title={i18n('Fachgebiet(e)')}>{fachgebiete}</ConfirmationField>
          <ConfirmationField title={i18n('Gericht der Eintragung')}>{gerichtDerEintragung}</ConfirmationField>
          <ConfirmationField title={i18n('Datum der Eintragung')}>
            {datumDerEintragung.format('DD.MM.YYYY')}
          </ConfirmationField>
          <ConfirmationField title={i18n('Mitgliedschaft Landesverband')}>
            {zustaendigerLandesverband || 'Nein'}
          </ConfirmationField>
          <ConfirmationField title={i18n('Versicherungssumme')}>{versicherungsSumme}</ConfirmationField>
          <ConfirmationField title={i18n('Versicherungsbeginn')}>
            {versicherungsbeginn.format('DD.MM.YYYY')}
          </ConfirmationField>
          <ConfirmationField title={i18n('Versicherungsende/Folgefälligkeit')}>{endDate}</ConfirmationField>
        </Section>

        {/* --- Personal Information --- */}
        <PersonalDataConfirmation {...personalProps} />

        {/* --- Risk --- */}
        <Section header={i18n('Fragen zum beantragten Risiko')}>
          <ConfirmationField
            broadTitle
            title={i18n('Wurde Ihnen das beantragte Risiko bereits einmal gekündigt oder abgelehnt?')}
          >
            {risikoAbgelehnt ? i18n('Ja') : i18n('Nein')}
          </ConfirmationField>
          <ConfirmationField
            broadTitle
            title={i18n(
              'Gab es in der Vergangenheit Schäden aus dem Haftpflichtrisiko Ihrer Sachverständigen-/Dolmetscher-Tätigkeit?'
            )}
          >
            {risikoSchaeden ? i18n('Ja') : i18n('Nein')}
          </ConfirmationField>
        </Section>

        {/* --- Payment Information --- */}
        <Section header={i18n('Bezahlung')}>
          <PaymentConfirmation {...paymentProps} />
          <ConfirmationField title={i18n('Zahlungsweise')}>{paymentTypeDisplayName}</ConfirmationField>
          {apiErrorMessages &&
            apiErrorMessages.length > 0 &&
            apiErrorMessages.map((error, index) => (
              <span className="error-message col-xs-12" key={`error-${index}`}>
                <span className="error-icon" />
                {error.validierungsText}
              </span>
            ))}
        </Section>

        {/* --- Additional Information --- */}
        <Section header={i18n('Vertragsabschluss')}>
          <ConfirmationField title={i18n('Kontaktaufnahme zu Werbezwecken')} halfWidth={false} broadTitle={false}>
            {promotion ? i18n('Ja') : i18n('Nein')}
          </ConfirmationField>
        </Section>

        <div className="row">
          <div className="col-xs-12 info-text">
            <p>
              Nach Vertragsabschluss (durch Klick auf den Button „Online abschließen“) erhalten Sie ein
              Bestätigungs-E-Mail über den Vertragsabschluss an die von Ihnen angegebene E-Mail- Adresse.
            </p>
            <p>
              An einem der darauffolgenden Arbeitstage erhalten Sie Ihre Versicherungspolizze an die von Ihnen
              angegebene Postadresse.
            </p>
          </div>
        </div>

        <div className="sticky-footer">
          <div className="page-step-wrapper__price">
            {i18n('Prämie (jährlich)')}&nbsp;
            {formatPrice(finalPrice, currency)}
            {paymentInterval !== PAYMENT_TYPE_ANNUAL && !!paymentVariants && paymentDetails(paymentInterval, quote)}
          </div>
          <NavigationButtons
            backLink={backLink}
            nextLink={{ go: onConfirm }}
            nextText={i18n('Online abschließen')}
            loading={loading}
            canContinue={!loading}
            onClick={this.onClick}
          />
        </div>
      </div>
    );
  }
}

export default Confirmation;
